import { Stepper_Edge_default } from "./chunk-YRPFQTRO.js";
import { Stepper_Node_default } from "./chunk-O2AX6OPQ.js";
import { Stepper_default } from "./chunk-T4YDIZEF.js";

// src/components/Stepper/index.tsx
var StepperComponent = Stepper_default;
StepperComponent.Node = Stepper_Node_default;
StepperComponent.Node.displayName = "Stepper.Node";
StepperComponent.Edge = Stepper_Edge_default;
StepperComponent.Edge.displayName = "Stepper.Edge";
export { StepperComponent };